import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";
import btn_scan from "../assets/btn_scan.png";
import footer from "../assets/footer.png";

import { useSelector } from "react-redux";
import { getUserData } from "../redux/slices/userSlices";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import { Scanner } from "@yudiel/react-qr-scanner";
import Api from "../components/api/api";
import { URL_API } from "../components/constants/api";

function Home() {
  const navigate = useNavigate();
  const dataUser = useSelector(getUserData);
  const [isScan, setIsScan] = useState(false);
  const [textScan, setTextScan] = useState("");
  const [dataScan, setDataScan] = useState<any | null>(null);

  useEffect(() => {
    if (!dataUser) {
      navigate("/");
    }
  }, [dataUser]);

  const handleScan = () => {
    setIsScan(true);
  };

  const onResultScan = (result: any) => {
    console.log(result);
    if (result) {
      if (result[0].format == "qr_code") {
        console.log("Code", result[0].rawValue);
        if (textScan === result[0].rawValue) return;
        setTextScan(result[0].rawValue);
      }
    }
  };

  useEffect(() => {
    if (textScan != "") {
      checkCode(textScan);
    }
  }, [textScan]);

  const checkCode = async (code: string) => {
    const params = { code_id: code, pg_id: dataUser.id };
    const res: any = await Api.post(URL_API.SCAN, params);
    console.log("handleSubmitForm", res, res.data);
    if (res.data.status) {
      setDataScan(res.data);
    } else {
      setDataScan(res.data);
    }
  };

  const handleAcceptCode = () => {
    acceptCode(textScan);
  };

  const acceptCode = async (code: string) => {
    const params = {
      code_id: code,
      pg_id: dataUser.id,
    };
    const res: any = await Api.post(URL_API.ACCEPT, params);
    if (res.data.status == false) {
      setDataScan(res.data);
    } else {
      handleScanAgain();
    }
  };

  const handleScanAgain = () => {
    setDataScan(null);
    setTextScan("");
    setIsScan(false);
  };
  return (
    <>
      <div className="w-full h-full min-h-screen">
        <div className="flex flex-col min-h-screen mx-auto  justify-between w-full text-base font-bold max-w-[480px] text-neutral-800">
          <img loading="lazy" src={logo} className="w-full" />
          <div className="flex flex-col w-full px-5">
            {dataScan ? (
              <>
                {dataScan.status == false ? (
                  dataScan.info ? (
                    <div className="flex flex-col justify-between mt-5 text-xl font-Micra font-bold text-white w-full mx-auto">
                      <div
                        className="w-full text-center mb-8 drop-shadow-[0px_2px_4px_rgba(0,0,0,0.5)]"
                        dangerouslySetInnerHTML={{ __html: dataScan.message }}
                      ></div>
                      <div className="w-full space-y-4">
                        {/* Event Title Field */}
                        <div className="flex">
                          <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                            Tên Event
                          </div>
                          <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium">
                            {dataScan.info.event_title}
                          </div>
                        </div>

                        {/* Ticket Code Field */}
                        <div className="flex">
                          <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                            Mã Vé
                          </div>
                          <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium overflow-hidden">
                            <div className="truncate">
                              {dataScan.info.ticket_code}
                            </div>
                          </div>
                        </div>

                        {/* Ticket Code Field */}
                        <div className="flex">
                          <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                            Số vé mua
                          </div>
                          <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium overflow-hidden">
                            <div className="truncate">
                              {dataScan.info.ticket_number}
                            </div>
                          </div>
                        </div>

                        {/* Ticket Code Field */}
                        <div className="flex">
                          <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                            Thời gian vé
                          </div>
                          <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium overflow-hidden">
                            <div className="truncate">
                              {dataScan.info.time_slot}
                            </div>
                          </div>
                        </div>

                        {/* Buyer Name Field */}
                        <div className="flex">
                          <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                            Người mua
                          </div>
                          <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium">
                            {dataScan.info.full_name}
                          </div>
                        </div>

                        {/* Buyer Name Field */}
                        <div className="flex">
                          <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                            Email mua
                          </div>
                          <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium">
                            {dataScan.info.email}
                          </div>
                        </div>

                        {/* Check-in Time Field (only show if available) */}
                        {dataScan.info.checked_in_at && (
                          <div className="flex">
                            <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                              Đã check-in
                            </div>
                            <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium">
                              {dataScan.info.checked_in_at}
                            </div>
                          </div>
                        )}
                      </div>
                      <Button
                        isLoading={false}
                        label="ĐÓNG"
                        handleClick={handleScanAgain}
                      />
                    </div>
                  ) : (
                    <div className="flex flex-col justify-between mt-8 text-xl font-Micra font-bold text-white w-[90%] mx-auto p-4">
                      <div className="w-full text-center mb-8 drop-shadow-[0px_2px_4px_rgba(0,0,0,0.5)]">
                        {dataScan.message}
                      </div>
                      <Button
                        isLoading={false}
                        label="ĐÓNG"
                        handleClick={handleScanAgain}
                      />
                    </div>
                  )
                ) : (
                  <div className="flex flex-col justify-between mt-5 w-full mx-auto">
                    <div className="w-full space-y-4">
                      {/* Event Title Field */}
                      <div className="flex">
                        <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                          Tên Event
                        </div>
                        <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium">
                          {dataScan.info.event_title}
                        </div>
                      </div>

                      {/* Ticket Code Field */}
                      <div className="flex">
                        <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                          Mã Vé
                        </div>
                        <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium overflow-hidden">
                          <div className="truncate">
                            {dataScan.info.ticket_code}
                          </div>
                        </div>
                      </div>

                      {/* Ticket Code Field */}
                      <div className="flex">
                        <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                          Số vé mua
                        </div>
                        <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium overflow-hidden">
                          <div className="truncate">
                            {dataScan.info.ticket_number}
                          </div>
                        </div>
                      </div>

                      {/* Ticket Code Field */}
                      <div className="flex">
                        <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                          Thời gian vé
                        </div>
                        <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium overflow-hidden">
                          <div className="truncate">
                            {dataScan.info.time_slot}
                          </div>
                        </div>
                      </div>

                      {/* Buyer Name Field */}
                      <div className="flex">
                        <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                          Người mua
                        </div>
                        <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium">
                          {dataScan.info.full_name}
                        </div>
                      </div>

                      {/* Buyer Name Field */}
                      <div className="flex">
                        <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                          Email mua
                        </div>
                        <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium">
                          {dataScan.info.email}
                        </div>
                      </div>

                      {/* Check-in Time Field (only show if available) */}
                      {dataScan.info.checked_in_at && (
                        <div className="flex">
                          <div className="bg-white text-blue-600 font-bold px-4 py-3 rounded-l-lg min-w-[110px] text-sm">
                            Đã check-in
                          </div>
                          <div className="bg-blue-600 text-white px-4 py-3 rounded-r-lg flex-1 text-sm font-medium">
                            {dataScan.info.checked_in_at}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="w-[80%] mx-auto">
                      <Button
                        isLoading={false}
                        label="Cancel"
                        handleClick={handleScanAgain}
                      />
                      <Button
                        isLoading={false}
                        label="OK"
                        handleClick={handleAcceptCode}
                      />
                    </div>
                  </div>
                )}
              </>
            ) : isScan ? (
              <>
                <div className="w-[70%] mx-auto">
                  <div className="flex flex-col justify-center w-full rounded-2xl border-4 border-solid border-[#53aaf9] overflow-hidden">
                    <div className="w-full">
                      <Scanner onScan={onResultScan} />
                    </div>
                  </div>
                  <Button
                    isLoading={false}
                    label="Trở Lại"
                    handleClick={handleScanAgain}
                  />
                </div>
              </>
            ) : (
              <>
                <div
                  onClick={handleScan}
                  className="flex justify-center items-center self-center px-4 w-[60%]"
                >
                  <img
                    loading="lazy"
                    src={btn_scan}
                    className="w-full aspect-square"
                  />
                </div>
              </>
            )}
          </div>
          <img loading="lazy" src={footer} className="w-full" />
        </div>
      </div>
    </>
  );
}

export default Home;
